import { Button }            from '@/components/ui/button'
import { Field }             from '@/components/ui/field';
import { Input }             from '@chakra-ui/react';
import { Link }              from 'react-router-dom';
import LoginCheckModel       from '@/models/services/fondations/LoginCheckModel';
import { PasswordInput }     from '@/components/ui/password-input';
import { Stack }             from '@chakra-ui/react';
import { Text }              from '@chakra-ui/react';
import UserMeModel           from '@/models/services/fondations/UserMeModel';
import authStore             from '@/stores/authStore';
import { toaster }           from '@/components/ui/toaster';
import { useForm }           from 'react-hook-form';
import { useNavigate }       from 'react-router-dom';
import { useTranslation }    from 'react-i18next';
import useTranslations       from '@/hooks/useTranslations';

interface FormValues {
  email: string
  password: string
}

const LoginForm = () => {
    const { t, i18n } = useTranslation();
    const { getNavigationTranslation } = useTranslations();
    const navigate = useNavigate();
    const fromStorage = sessionStorage.getItem('loginRedirectPath');
    const from = fromStorage || `/${i18n.language}/`;

    const {
        formState: { errors, isSubmitting },
        setError,
        handleSubmit,
        register,
    } = useForm<FormValues>()

    const onSubmit = handleSubmit(async (data) => {
        const { email, password } = data;

        const newLoginCheck = new LoginCheckModel();
        try { 
            const {token, refreshToken} = await newLoginCheck
                .patch({ 
                    _password: password, 
                    _username: email, 
                    from: 1 
                }, { 
                    stringifyAttributes: true 
                });
            authStore.setToken(token);
            authStore.setRefreshToken(refreshToken);

            const user = await new UserMeModel().fetch();
            authStore.setCurrentUser(user);
            
            sessionStorage.removeItem('loginRedirectPath');
            navigate(`/${i18n.language}/${from.split('/')[2]}`);

        } catch (error) {
            setError('email', {});
            setError('password', {});

            // L'API renvoie une 401 dont le message distingue les identifiants
            // invalides d'un compte dont l'e-mail n'a pas encore été vérifié.
            const apiMessage = (error as any)?.connectorError?.response?.data?.message;
            const isEmailNotVerified = apiMessage === 'Email account not verified';

            toaster.create({
                title: t(`pages.login.form.email.errors.${isEmailNotVerified ? 'emailNotVerified' : 'unauthorized'}`),
                type: 'error'
            })
            console.log(error);
        }
    })

  return (
    <form onSubmit={onSubmit} style={{width: "100%"}}>
        <Stack gap="16" >
            <Stack gap="4">
                <Field
                    label={<Text className="poppins-semibold" fontWeight="bold">{t('pages.login.form.email.label')}</Text>}
                    invalid={!!errors.email}
                >
                    <Input
                        placeholder={t('pages.login.form.email.label')}
                        {...register("email", { required: true })}
                    />
                    {errors.email && errors.email.type === 'required' && <Text color="red">{t('pages.login.form.email.errors.required')}</Text>}
                </Field>
                <Field
                    label={<Text className="poppins-semibold" fontWeight="bold">{t('pages.login.form.password.label')}</Text>}
                    invalid={!!errors.password}
                >
                    <PasswordInput
                        placeholder={t('pages.login.form.password.label')}
                        {...register("password", { required: true })}
                    />
                    {errors.password && errors.password.type === 'required' && <Text color="red">{t('pages.login.form.password.errors.required')}</Text>}
                </Field>
                <Link to={getNavigationTranslation('resetPassword', 'path')}>
                    <Text textAlign={{ base: "start", lg: "center" }} textDecoration="underline">{t('pages.login.resetPassword')}</Text>
                </Link>
            </Stack>

            <Button 
                variant="solid" 
                type="submit" 
                width="100%"
                loading={isSubmitting}
            >
                {t('pages.login.form.actions.login')}
            </Button>
        </Stack>
    </form>
  )
}

export default LoginForm;